import {
  pgTable,
  uuid,
  text,
  boolean,
  integer,
  jsonb,
  timestamp,
  index,
  type AnyPgColumn,
} from "drizzle-orm/pg-core";
import type { CategoryTranslation, Translations } from "./translations.js";

// Optional curation overlay shown in the storefront mega menu. Edited from
// the admin Categories page; all fields optional.
export type CategoryMeta = {
  featured?: {
    eyebrow?: string;
    head?: string;
    cta?: string;
    ctaHref?: string;
    image?: string;
    bg?: string;
  };
};

export const categories = pgTable(
  "categories",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    parentId: uuid("parent_id").references((): AnyPgColumn => categories.id, {
      onDelete: "set null",
    }),
    slug: text("slug").notNull().unique(),
    translations: jsonb("translations")
      .$type<Translations<CategoryTranslation>>()
      .notNull()
      .default({}),
    position: integer("position").notNull().default(0),
    active: boolean("active").notNull().default(true),
    color: text("color"),
    imageUrl: text("image_url"),
    meta: jsonb("meta").$type<CategoryMeta>().notNull().default({}),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    parentIdIdx: index("categories_parent_id_idx").on(t.parentId),
  })
);

export type Category = typeof categories.$inferSelect;
export type NewCategory = typeof categories.$inferInsert;
